module.exports = __webpack_public_path__ + "img/wallet.0dc9a0a2.png";